import { route } from '@diana/core';

export const routeUrls = {
  signIn: route<null, null>('/app/signin-oidc'),
  signInRefresh: route<null, null>('/app/refresh-oidc'),

  environment: route<null, null>('/environment'),
  createEnvironment: route<null, null>('/environment/create'),

  ecosystem: route<null, null>('/ecosystem'),
  createEcosystem: route<null, null>('/ecosystem/create'),
  selectEcosystem: route<null, null>('/ecosystem/select'),

  checkout: route<null, null>('/ecosystem/checkout'),
  checkoutReturn: route<null, null>('/ecosystem/checkout/return'),

  legacyWork: route<{ flowId: string }, null>('/app/workboard/:flowId'),
  home: route<{ environment: string }, { modal?: string }>('/:environment/home'),
  root: route<{ environment: string }, null>('/:environment'),
  workflows: route<{ environment: string }, { modal?: string; inviteToFlowId?: string }>(
    '/:environment/workflows',
  ),
  flowBuilder: route<
    { environment: string; flowId: string },
    { preview?: boolean; flowResourceType?: string }
  >('/:environment/flow/:flowId/builder'),
  workboard: route<{ environment: string; flowId: string }, null>(
    '/:environment/workboard/:flowId',
  ),
  baseWorkboard: route<null, null>('/:environment/workboard/'),
  work: route<{ environment: string; workId: string }, { section?: string }>(
    '/:environment/work/:workId',
  ),
  baseWork: route<null, null>('/:environment/work/'),
  workVideoChat: route<{ environment: string; workId: string }, { section?: string }>(
    '/:environment/work/:workId/video-chat',
  ),
  workPrint: route<{ environment: string; workId: string; printContext: string }, null>(
    '/:environment/work/print/:workId/:printContext',
  ),
  legacyWorkPrint: route<{ workId: string; printContext: string }, null>(
    '/app/print/v2/work/:workId/:printContext',
  ),
  performance: route<{ environment: string }, null>('/:environment/performance'),
  performanceReport: route<{ environment: string; reportId: string }, null>(
    '/:environment/performance/:reportId',
  ),
  performanceReportBuilder: route<{ environment: string; reportId: string }, null>(
    '/:environment/performance/:reportId/builder',
  ),
  people: route<{ environment: string }, null>('/:environment/people'),
  user: route<{ environment: string; userId: string }, null>('/:environment/people/:userId'),
  thingsGroups: route<{ environment: string }, null>('/:environment/things'),
  things: route<{ environment: string; flowOriginId: string }, null>(
    '/:environment/things/:flowOriginId',
  ),
  thing: route<{ environment: string; thingId: string }, null>('/:environment/thing/:thingId'),
  assetsGroup: route<{ environment: string }, null>('/:environment/assets'),
  assets: route<{ environment: string; flowOriginId: string }, null>(
    '/:environment/assets/:flowOriginId',
  ),
  asset: route<{ environment: string; thingId: string }, null>('/:environment/asset/:thingId'),
  legacyOpenFile: route<{ attachmentId: string; resourceType: string; resourceId: string }, {}>(
    '/app/open-file/:attachmentId/:resourceType/:resourceId',
  ),
  notFound: route<{ environment: string }, null>('/*'),

  // temporary route; for sandbox testing only; remove later
  schemaExplorer: route<null, null>('/:environment/schema'),
};
